import React from "react";
import Page from "../../components/global/Page";
import Terms from "../../components/global/Terms";
import GeneralClauses from "../../components/global/GeneralClauses";
import BBPClauses from "../../components/global/BBPClauses";

const TermsPage = () => {
  return (
    <Page title="Términos y Condiciones">
      <Terms />
      <GeneralClauses />
      <h3>VIII. CLÁUSULAS ESPECÍFICAS POR CERTIFICACIÓN. –</h3>
      <BBPClauses />
    </Page>
  );
};

export default TermsPage;
